module.exports = __webpack_public_path__ + "img/DLee.18a306dd.png";